export enum ImageEvents {
  imageCompressed = 'Image Compressed',
}

export enum ImageCompressionField {
  CompressedMediaType = 'Compressed Media Type',
  CompressedSizeKB = 'Compressed Size (KB)',
  CompressionDurationMs = 'Compression Duration (ms)',
  CompressionRate = 'Compression Rate',
  OriginalMediaType = 'Original Media Type',
  OriginalSizeKB = 'Original Size (KB)',
  Source = 'Source',
}
